import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Exam from '../exams/exam';

class ExamModal extends Component {
    
    render() {
        return (
            <article className={this.props.examModalClass ? "popup-show exam-view-popup popup-wrap flex-column align-items-center justify-content-center position-absolute" : "exam-view-popup popup-wrap flex-column align-items-center justify-content-center position-absolute"}>
                <ul className="popup-container d-flex flex-column m-0 p-0">
                    <li className="popup-header d-flex align-items-center">
                        <h1 className="title w-100 m-0 text-center">문제 보기</h1>
                        <button type="button" className="btn close-btn popup-close-btn" onClick={this.props.onClose}>
                            <span className="icon-wrap">
                                    <svg className="icon close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path className="fill" d="M153.212,158l4.537-4.537a.857.857,0,0,0-1.212-1.212L152,156.788l-4.537-4.537a.857.857,0,0,0-1.212,1.212L150.788,158l-4.537,4.537a.857.857,0,0,0,1.212,1.212L152,159.212l4.537,4.537a.857.857,0,0,0,1.212-1.212Z" transform="translate(-140 -146)" fill="#fff"/>
                                    </svg>
                                </span>
                        </button>
                    </li>
                    <li className="popup-body">
                        <p className="warning">
                            ※ 전체/체크/안 푼 문제 탭을 클릭하여 해당 문제를 확인할 수 있습니다.<br/>※ 문제를 더블클릭 시 해당 문제로 이동하여 답안 수정이 가능합니다.
                        </p>

                        <Tabs className="tab-container">
                            <TabList className="tabs">
                                <Tab className="tab">전체 문제 (30)</Tab>
                                <Tab className="tab">체크 문제 (30)</Tab>
                                <Tab className="tab">안 푼 문제 (30)</Tab>
                            </TabList>

                            <div className="tab-content scroll-wrapper">
                                <TabPanel className="d-flex m-0 p-0 exam-container all-exam-container">
                                    <li className="exam exam-move"><Exam /></li>
                                    <li className="exam exam-move"><Exam /></li>
                                </TabPanel>
                                <TabPanel className="d-flex m-0 p-0 exam-container check-exam-container">
                                    <li className="exam exam-move"><Exam /></li>
                                    <li className="exam exam-move"><Exam /></li>
                                </TabPanel>
                                <TabPanel className="d-flex m-0 p-0 exam-container none-exam-container">
                                    <li className="exam exam-move"><Exam /></li>
                                    <li className="exam exam-move"><Exam /></li>
                                </TabPanel>
                            </div>
                        </Tabs>
                    </li>
                </ul>
            </article>
        );
    }
}

export default ExamModal;